import { BedragValidation, DateValidation, IsRequiredValidation } from "@generation/form";
import { translate } from "../Locales/translate";
import { DateNotInFutureValidation } from "./date-not-in-future";
import { DateNotInRangeValidation } from "./date-not-in-range";
import { MaximumNumberValidation } from "./maximumNumberValidation";
import { formatNumberAsAmount } from "./number";

export const IsRequiredValidationFactory = () =>
  new IsRequiredValidation(false, (label?: string) =>
    translate("IsRequiredValidationFactoryValidationText", { label: label || "" })
  );

export const IsBedragValidationFactory = () =>
  new BedragValidation(false, (label?: string) =>
    translate("IsBedragValidationFactoryValidationText", { label: label || "" })
  );

export const DateValidationFactory = () =>
  new DateValidation(true, (label?: string) =>
    translate("DateValidationFactoryValidationText", { label: label || "" })
  );

export const DateNotInFutureValidationFactory = () =>
  new DateNotInFutureValidation(true, (label?: string) =>
    translate("DateNotInFutureValidationFactoryText", { label: label || "" })
  );

export const DateNotInRangeValidationFactory = (minYear: number, maxYear: number) => {
  const isRequired = true;

  const customErrorMessage = (label: string) =>
    translate("DateNotInRangeValidationFactoryText", {
      label: label || "",
      minYear: `${minYear}`,
      maxYear: `${maxYear}`
    });

  return new DateNotInRangeValidation(true, minYear, maxYear, customErrorMessage);
};

export const HasMaximumValueValidationFactory = (maxValue: number, isRequired: boolean) =>
  new MaximumNumberValidation(maxValue, isRequired, (label: string) =>
    translate("MaximumNumberValidationText", {
      label: label,
      maximumBedrag: formatNumberAsAmount(maxValue)
    })
  );
